import { render, staticRenderFns } from "./WelshNotification.vue?vue&type=template&id=a86cdb0c&scoped=true&"
import script from "./WelshNotification.vue?vue&type=script&lang=js&"
export * from "./WelshNotification.vue?vue&type=script&lang=js&"
import style0 from "./WelshNotification.vue?vue&type=style&index=0&id=a86cdb0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86cdb0c",
  null
  
)

export default component.exports